import { useState, useEffect } from "react";
import queryString from "query-string";

export const useGetQuery = () => {
  const [parsedData, setParsedData] = useState({});

  const getQuery = () => {
    const query = window.location.search;
    const parsed = queryString.parse(query);
    setParsedData(parsed);
  };

  useEffect(() => {
    getQuery();
  }, []);

  return { parsedData };
};
